import * as tslib_1 from "tslib";
import onCloseInlineCompose from './onCloseInlineCompose';
import removeInfoBarMessage from './removeInfoBarMessage';
import { cleanUpSaveActionManager } from '../actions/trySaveMessage';
import { unsubscribeToRecipientsChangeEvent } from '../orchestrators/onRecipientsInComposeChange';
import { removeComposePlugins } from '../plugins/ComposePlugins';
import { getStore } from '../store/composeStore';
import { removeViewStateFromBeforeUnloadHandler } from '../utils/beforeUnloadHandler';
import { getComposeHostItemIndex, lazyOnComposeClose } from 'owa-addins-core';
import { onComposeClosed } from 'owa-mail-actions/lib/composeActions';
import { CloseComposeActionName } from 'owa-mail-compose-action-names';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { findPopoutByData, lazyClosePopout } from 'owa-popout-store';
import { closeAllSxS } from 'owa-sxs-store';
import { isDeepLink } from 'owa-popout';
import { findTabByData, lazyCloseTab } from 'owa-tab-store';
import { action } from 'satcheljs/lib/legacy';
function onCloseComposeInReadingPane(viewState, inlineComposeParentTabId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!viewState.isInlineCompose) return [3 /*break*/, 1];
                    onCloseInlineCompose(viewState.conversationId, inlineComposeParentTabId);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, closeAllSxS('closeCompose')];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export default action(CloseComposeActionName)(function closeCompose(viewState) {
    removeViewStateFromBeforeUnloadHandler(viewState);
    removeComposePlugins(viewState);
    cleanUpSaveActionManager(viewState);
    removeInfoBarMessage(viewState);
    unsubscribeToRecipientsChangeEvent(viewState);
    var state = getStore();
    var closeComposePromise = Promise.resolve();
    var closeTabPromise = Promise.resolve();
    var closePopoutPromise = Promise.resolve();
    if (state.defaultViewState == viewState) {
        closeComposePromise = onCloseComposeInReadingPane(viewState);
        if (!viewState.isInlineCompose) {
            mailModuleOrchestrator.lazyOnCloseCompose.importAndExecute();
        }
        state.defaultViewState = null;
        if (isDeepLink() && window.opener) {
            window.close();
        }
    }
    else if (state.pendingViewState == viewState) {
        state.pendingViewState = null;
    }
    else if (state.floatingViewStates.has(viewState.composeId)) {
        state.floatingViewStates.delete(viewState.composeId);
    }
    else {
        if (isDeepLink() && window.opener) {
            window.close();
        }
        else {
            var tab = findTabByData(viewState);
            if (tab) {
                closeComposePromise = onCloseComposeInReadingPane(viewState, tab.parentTabId);
                closeTabPromise = lazyCloseTab.importAndExecute(tab, true /*forceClose*/);
            }
            var popout = findPopoutByData(viewState);
            if (popout) {
                closeComposePromise = onCloseComposeInReadingPane(viewState);
                closePopoutPromise = lazyClosePopout.importAndExecute(popout, true /*forceClose*/);
            }
        }
    }
    isMailFeatureEnabled('rp-addins') &&
        lazyOnComposeClose.import().then(function (onComposeClose) {
            onComposeClose(getComposeHostItemIndex(viewState.composeId));
        });
    Promise.all([closeComposePromise, closeTabPromise, closePopoutPromise]).then(function () {
        onComposeClosed();
    });
});
//# sourceMappingURL=closeCompose.js.map